import { useMutation } from "@tanstack/react-query"

import apiClient from "@api/client"

const MUTATION_KEY = ["CREATE_DELIVERY_ADDRESS"]

type CreateDeliveryAddressParams = {
  google_place_id: string
  preferences: unknown
}

type CreateDeliveryAddressResponse = {
  user_delivery_address: {
    address_id: number
    user_delivery_address_id: number
    // ...
  }
}

export const useCreateDeliveryAddress = () => {
  return useMutation({
    mutationKey: MUTATION_KEY,
    mutationFn: async (address: CreateDeliveryAddressParams) => {
      const response = await apiClient.post<
        CreateDeliveryAddressResponse,
        CreateDeliveryAddressParams
      >("user/delivery-address", address)

      if (!response) throw new Error("Failed to create delivery address")

      return response.body.user_delivery_address.user_delivery_address_id
    },
  })
}
